import { StyleSheet, View } from 'react-native';

import { Skeleton, SkeletonTextBlock, tokens } from '@fhs/ui';
import { HStack } from '@fhs-legacy/universal-components';

export function DonationContainerSkeleton() {
  return (
    <View style={[styles.container]}>
      <HStack space="$2" alignItems="center" paddingLeft="$3">
        <Skeleton style={styles.imageContainer} />
        <SkeletonTextBlock lines={1} style={styles.textContainer} />
      </HStack>
      <View style={styles.contentContainer}>
        <Skeleton style={styles.skeletonButton} />
        <Skeleton style={styles.skeletonButton} />
        <Skeleton style={styles.skeletonButton} />
        <Skeleton style={styles.skeletonButton} />
        <Skeleton style={styles.skeletonButton} />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingVertical: 13,
    paddingHorizontal: 8,
    marginBottom: 24,
    width: '100%',
    height: 186,
    borderColor: tokens.colors.$black10,
    borderWidth: 1,
    borderRadius: 8,
  },
  imageContainer: {
    height: 60,
    width: 60,
    borderRadius: 50,
  },
  contentContainer: {
    flex: 1,
    flexDirection: 'row',
    paddingVertical: 13,
    gap: 8,
    justifyContent: 'center',
  },
  textContainer: {
    width: '85%',
    minHeight: 65,
    padding: 20,
  },
  skeletonButton: {
    flex: 1,
    minWidth: 20,
    maxWidth: 213,
    height: 48,
    borderRadius: 100,
  },
});
